import { Component } from '@angular/core';
import { PrintService } from './print.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'aubiasi-admin';
  constructor(public printService: PrintService) {}
}
